import { Badge, Group, Text } from "@mantine/core";

import type { ActivityActorType } from "../../services/api";

// Users go unmarked; anything else acting on its own is badged, so a change
// made by an integration or a station never reads as a person's
const ACTOR_BADGES: Record<Exclude<ActivityActorType, "user">, { label: string; color: string }> = {
	apiKey: { label: "API", color: "grape" },
	spaceos: { label: "API", color: "grape" },
	station: { label: "Station", color: "teal" },
	system: { label: "System", color: "gray" },
};

interface ActivityActorProps {
	actorName: string;
	actorType: ActivityActorType;
}

function ActivityActor({ actorName, actorType }: ActivityActorProps) {
	return (
		<Group
			gap={6}
			wrap="nowrap">
			<Text
				size="sm"
				c="dimmed">
				{actorName}
			</Text>
			{actorType !== "user" && (
				<Badge
					size="xs"
					variant="light"
					color={ACTOR_BADGES[actorType].color}>
					{ACTOR_BADGES[actorType].label}
				</Badge>
			)}
		</Group>
	);
}

export default ActivityActor;
